const variable = {
  primaryColor: '#57a708',
  primaryColorHighlight: 'rgba(87, 167, 8, 0.4)',
  primaryColorHighlightSolid: 'rgb(188, 220, 156)',
  callBtnColor: '#57a708',
  smsBubbleBackgroundColor: '#ecffd9',
  brandFontColor: '#49166d',
  brandFontColorHighlight: 'rgba(73,22,109, 0.4)',
  c2dArrowColor: '#66cc00',
  addMeetingBtnColor: '#2b8000',
  addMeetingBtnTextColor: '#ffffff',
};

export default variable;
